// pages/DashboardPage.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useModal } from '../context/ModalContext';
import API from '../api/MainApi';
import './DashboardPage.css';

const DashboardPage = () => {
    const { hasPermission } = useAuth();
    const { showAlert } = useModal();
    const [stats, setStats] = useState({
        products: 0,
        activeProducts: 0,
        archiveProducts: 0
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadStats();
    }, []);

    const loadStats = async () => {
        try {
            const data = await API.getProducts();
            const activeProducts = data.data.filter(p => p.status === 'active');
            const archiveProducts = data.data.filter(p => p.status === 'archive');
            
            setStats({
                products: data.data.length,
                activeProducts: activeProducts.length,
                archiveProducts: archiveProducts.length
            });
        } catch (error) {
            showAlert('Ошибка', 'Не удалось загрузить статистику', 'error');
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <div className="loading">Загрузка...</div>;

    return (
        <div className="dashboard-page">
            <div className="stats-grid">
                <div className="stat-card">
                    <h3>Всего товаров</h3>
                    <div className="stat-value">{stats.products}</div>
                </div>
                <div className="stat-card">
                    <h3>Активные</h3>
                    <div className="stat-value">{stats.activeProducts}</div>
                </div>
                <div className="stat-card">
                    <h3>В архиве</h3>
                    <div className="stat-value">{stats.archiveProducts}</div>
                </div>
            </div>

            <div className="quick-actions">
                <h2>Быстрые действия</h2>
                <div className="actions-grid">
                    {hasPermission('canManageProducts') && (
                        <Link to="/products/create" className="action-card">
                            ➕ Добавить товар
                        </Link>
                    )}
                    <Link to="/products" className="action-card">
                        📦 Все товары
                    </Link>
                    {hasPermission('canManageAdmins') && (
                        <Link to="/admins" className="action-card">
                            👥 Администраторы
                        </Link>
                    )}
                    {hasPermission('canViewOrders') && (
                        <Link to="/orders" className="action-card">
                            📦 Заказы
                        </Link>
                    )}
                </div>
            </div>

            {/* <div className="recent-section">
                <h2>Последние товары</h2>
                 Здесь можно добавить список последних товаров 
            </div> */}

        </div>
    );
};

export default DashboardPage;